import React from 'react';
import { authTokenService } from '@/services/auth/AuthTokenService';

/**
 * React hook to watch for access token changes
 * @returns The current access token
 */
export function useAccessToken(): string | null {
  const [token, setToken] = React.useState<string | null>(authTokenService.getAccessToken());

  React.useEffect(() => {
    return authTokenService.subscribe(setToken);
  }, []);

  return token;
} 